<button *ngIf="actionVisible" type="button" (click)="doAction()" mat-menu-item>
    <mat-icon>replay</mat-icon><span>{{actionText}}</span>
</button>